import { UserDTO } from '../../components/user-management/auth.type';

export type Country = {
  countryCode: string;
  name: string;
};
export type State = {
  stateCode: string;
  name: string;
};
export interface HistoryDTO {
  id: string;
  summary?: string;
  content?: string;
  createdOn?: string;
  updatedOn?: string;
  createdBy?: UserDTO;
  updatedBy?: UserDTO;
}

export interface NoteDTO {
  id?: string;
  content: string;
  isPayappNote?: boolean;
  createdOn?: string;
  updatedOn?: string;
  isNote?: boolean;
  isAutoGenerated?: boolean;
  reportId?: string;
  createdBy?: UserDTO;
  updatedBy?: UserDTO;
}

export interface FileUploadDTO {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  blobName: string;
  createdOn: string;
  createdBy: UserDTO;
}

export enum ReportTypes {
  QCC = 'Quarterly Construction Cost',
  CC = 'Construction Cost',
  CA = 'Cost Analysis',
}
